import type { Webhook } from "@repo/shared/types";
import { useQuery, useQueryClient } from "@tanstack/react-query";
import { getWebhooks } from "@/lib/api/webhooks";

export function useWebhooks({ enabled = true }: { enabled?: boolean } = {}) {
  const { data, error, isLoading } = useQuery({
    queryKey: ["webhooks"],
    queryFn: () => getWebhooks(),
    enabled,
  });
  const queryClient = useQueryClient();
  const mutate = () => queryClient.invalidateQueries({ queryKey: ["webhooks"] });
  return { webhooks: (data ?? []) as Webhook[], error, isLoading, mutate };
}
